export class StatusNotificacao {

isVisualizado: boolean;
isExcluido: boolean;

    constructor(isVisualizado: boolean, isExcluido: boolean) {
        this.isVisualizado = isVisualizado;
        this.isExcluido = isExcluido;
    }
}